import { render, staticRenderFns } from "./emailRecipiants.vue?vue&type=template&id=69e5d6a3&"
import script from "./emailRecipiants.vue?vue&type=script&lang=js&"
export * from "./emailRecipiants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports